import { DataErrorParser } from "@/store/shared/DataErrorParser";

const handleError = (error, message) => {
  const dataError = new DataErrorParser(error, message);
  const msg = dataError.fullMessage();
  return Promise.reject(new Error(msg));
};

export { handleError };
